import { post, del, put } from './requests'

export function createTemplatePlaceholder ({ documentTemplateId, contactPlaceholderId, copiedContact = false }) {
  return post(
    `document_templates/${documentTemplateId}/contact_placeholders`,
    { documentTemplateContactPlaceholder: { contactPlaceholderId, copiedContact } }
  )
}

export function deleteTemplatePlaceholder ({ documentTemplateId, contactPlaceholderId }) {
  return del(`document_templates/${documentTemplateId}/contact_placeholders/${contactPlaceholderId}`)
}

export function updateTemplatePlaceholder ({ documentableId, recipientId, copiedContact }) {
  return put(
    `document_templates/${documentableId}/contact_placeholders/${recipientId}`,
    { documentTemplateContactPlaceholder: { copiedContact } }
  )
}
